import React from 'react';
import { Outlet, Navigate } from 'react-router-dom';
import UserDashboardHeader from '../../Common/Layout/UserDashboardHeader';
import { useAuth } from '../../Common/Configurations/AuthContext';

const AccountLayout = () => {
    const { user, loading } = useAuth();
    if (loading) {
        return <div className='text-center'>
            <img src="/assets/images/loader.webp" width={"64px"} height={"64px"}></img>
            Loading, Please wait...</div>; // Or a spinner/skeleton loader
    }
    if (!user) {
        return <Navigate to="/" replace />;
    }
    return (
        <>
            <UserDashboardHeader />
            {/* The Outlet will render the specific account page (e.g., MyProfile, ChangePassword) */}
            <Outlet />
        </>
    );
};

export default AccountLayout;